import config from "flow/config";
import { requiresHeartbeat } from "./ajax/httpStatusInterpret";
import { AjaxError, AjaxErrorType } from "./ajax/ajaxTypes";

function tick(baseUrl: string, timeout?: number): Promise<any> {
    const script = document.createElement("script");

    const scriptPromise = new Promise((resolve, reject) => {
        script.onload = resolve;
        script.onerror = (e: Event) => {
            reject({
                type: AjaxErrorType.NetworkError,
                status: 0,
                statusText: "heartbeat error",
                body: e
            } as AjaxError);
        };
        script.async = true;
        script.src = baseUrl + config.partialUrls.heartbeat;
        document.body.appendChild(script);
    });

    const removeScript = () => {
        try {
            document.body.removeChild(script);
        } catch (e) {
            console.warn(e);
        }
    };

    scriptPromise.then(removeScript).catch(removeScript);

    if (timeout) {
        return Promise.race([
            scriptPromise,
            new Promise((_, reject) =>
                setTimeout(
                    () =>
                        reject({
                            type: AjaxErrorType.NetworkError,
                            status: 0,
                            statusText: "timeout",
                            body: "Heartbeat timeout"
                        } as AjaxError),
                    timeout
                )
            )
        ]);
    } else {
        return scriptPromise;
    }
}

function keepAlive(baseUrl: string, interval: number) {
    setInterval(() => {
        tick(baseUrl).catch(e => {
            console.warn("Heartbeat tick failed:", baseUrl, e);
        });
    }, interval);
}

async function weAreGettingRedirected(baseUrl: string) {
    const url = `${baseUrl}${config.partialUrls.heartbeat}?${new URLSearchParams({ ajax: "true" })}`;

    const request = new Request(url, {
        credentials: "same-origin" as RequestCredentials,
        headers: new Headers({
            "Content-Type": "text/javascript",
            "ajax-no-cross-domain-redirect": "true"
        })
    });

    const response = await fetch(url, request);
    return response.ok === false && requiresHeartbeat(response.status);
}

export default {
    tick,
    keepAlive,
    weAreGettingRedirected
};
